package presentation.screens.business.inventory.category.edit

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import com.friendly.shared.component.CustomDefaultBtn
import com.friendly.shared.component.ErrorSuggestion
import common.asset.ImageAsset
import component.input.CustomTextField
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.alert.handler.AlertHandler
import feature.productCategory.viewModel.ProductCategoryViewModel
import theme.ThemeColor

class EditCategoryScreen : Screen {


    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val viewModel = ProductCategoryViewModel()
        var editCategory = viewModel.editCategory.collectAsState()
        var name by remember {
            mutableStateOf(editCategory.value?.Name?.let { TextFieldValue(it) }
                ?: TextFieldValue(""))
        }
        val nameErrorState = remember { mutableStateOf(false) }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = "Update Category", onBackPress = {
                navigator?.pop()
            })
            AppLoader(viewModel)
            Spacer(modifier = Modifier.height(50.dp))
            CustomTextField(
                value = editCategory.value?.Name ?: "",
                placeholder = "Category name",
                trailingIcon = ImageAsset.person,
                label = "Name",
                errorState = nameErrorState.value,
                keyboardType = KeyboardType.Email,
                visualTransformation = VisualTransformation.None
            ) { newEmail ->
                name = newEmail
            }

            Spacer(modifier = Modifier.height(10.dp))
            if (nameErrorState.value) {
                ErrorSuggestion("Please enter valid name.")
            }
            CustomDefaultBtn(shapeSize = 50f, btnText = "Update") {
                val nameErrorState = name.text.length < 4
                if (!nameErrorState) {
                    if (editCategory.value?.Id?.isEmpty() != true) {
                        viewModel.updateCategory(name.text, editCategory.value!!.Id) {
                            navigator?.pop()
                        }

                    }
                } else {
                    AlertHandler.shared().showAlert("Error!", "Please enter valid input")
                }
            }
        }
    }
}